import { Fragment, useEffect, useState } from 'react';
import { Box, CircularProgress, FormControl, InputLabel, Select, SelectChangeEvent, Typography } from '@mui/material';

import { Survey2DLines } from 'features/seismic/models/interfaces/I2DLines';
import { useGetAll2DLines } from './api/useSeismicLineController';
import { useSeismicStore } from 'features/seismic/stores/useSeismicStore';

export function SeismicLineSelect({ attributes, onChange, selectedLine }: Props) {

    const { surveyMetadata } = useSeismicStore(state => ({
        surveyMetadata: state.surveyMetadata
    }));

    const handleChange = ( lineName: string) => {
        if (attributes) {
            const selected = attributes.find(el => el.LineName === lineName);
            if (selected) {
                onChange(selected);
            }
        }
    };

    return  (
        <Fragment>
            <Fragment>
                <Box style={{display: 'flex', flexDirection: 'row'}}>
                    {
                        <FormControl size='small'>
                            <InputLabel id='2d-line-selector-input-label'>
                                {attributes.length > 0 ? 'Line' : 'No other lines available'}
                            </InputLabel>
                            <Select
                                labelId='2d-line-selector-input-label'
                                style={{fontSize: '14px', color:'#ffffff', padding:'3px', marginRight: '5px'}}
                                value={selectedLine}
                                native
                                onChange={(event) => !!event.target.value && handleChange(event.target.value)}
                                id='2d-line-selector-input'
                                disabled={attributes.length === 0}
                                label={attributes.length > 0 ? 'Line' : 'No other lines available'}
                            >
                                {
                                    attributes.map((el,idx) => <option style={{padding: '10px', color: '#000000'}} key={'product-' + idx + '-' + el.SurveyId} value={el.LineName}>{el.LineName}</option>)
                                }
                            </Select>
                        </FormControl>
                    }
                </Box>
            </Fragment>
        </Fragment>
    );
}

interface Props {
    attributes: Survey2DLines[];
    onChange: (value: Survey2DLines | undefined) => void;
    selectedLine: string|null;
}